<template>
  <div class="designer-v2-page-main">
    <DesignerV2 />
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  data: function() {
    return {
    }
  },
  props: {
  },
  methods: {
  },
  mounted() {
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.designer-v2-page-main {
  padding: 10px 45px;
}
</style>